import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("prabhat_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("prabhat_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("prabhat_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("prabhat_token");
    setUser(null);
    window.location.href = "/login";
  };

  const roleLevel = { viewer: 0, data_entry: 1, accountant: 2, admin: 3, super_admin: 4 };
  const canWrite = user && roleLevel[user.role] >= 1;
  const isAdmin = user && roleLevel[user.role] >= 3;

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, canWrite, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
